import { cloneDeep, differenceWith, uniq } from 'lodash'
import deepEqual from 'deep-equal'

import { randstr, insertAt, moveInArray } from '../../lib/Tools'
import createDuck from '../lib/MetagnosticDuck'
import ActionTypes from '../actions/ActionTypes.js'
import { getRoute, getRoutes } from '../lib/APIClient'
import {
  canMove, move, multiMoveDown, multiMoveUp,
  getNewItem, removeItem, addKeyToItem,
  getRouteActivities
} from '../ducks/routes.aux.js'

import { getEmptyTransport } from '../lib/emptyTransport.js'
import fixOrder from '../routes/fixOrder.js'

export const emptyRoute = {
  // _id
  name: "",
  agenda: [{ type: "day", key: "firstday" }],
  expenses: [],
  usedTemplateRoutes: [],
}

// i may need a function to clone de routes array. i dont think it matters, bc when
// it gets updated it will be copied.
//~ const getEmptyRoute = () => cloneDeep(emptyRoute)

/**
 *
 */

function expensesUpdatesReducer(state = [], action) {
  if (action.type != ActionTypes.UPDATE_ONE_ROUTES) {
    return state
  }
  // TODO this doesnt work, just because expenses also have an _id D:
  else if (action.subtype == "add_block") {
    return state.concat(differenceWith(action.payload.blockRoute.expenses, state, deepEqual))
  }
  else if (action.subtype == "replace_with_block") {
    return cloneDeep(action.payload.blockRoute.expenses)
  }
  // TODO stop updating the whole expenses list every time, idiot
  else if (action.subtype == "update_expenses") {
    return action.expenses
  }
  else return state
}

/**
 * which template/blocks have been used
 */

function usedTemplatesReducer(state = [], action) {
  const { subtype } = action

  if (subtype == "add_block") {
    return uniq(state.concat(action.payload.blockRoute._id))
  }
  else if (subtype == "replace_with_block") {
    return [action.payload.blockRoute._id]
  }
  else return state
}

/**
 * Agenda sub-reducer
 */
// WARNING: duplicating intial agenda state
function agendaUpdatesReducer(state = [{ type: "day", key: "firstday" }], action) {
  const { type, subtype, itarget } = action

  if (type != ActionTypes.UPDATE_ONE_ROUTES) return state

  const up = subtype == "up"
  if (subtype == "up" || subtype == "down") {
    return (canMove(state, itarget, up) ? move(state, itarget, up) : state)
  }

  if (subtype == "multi_move") return (
    (action.dir == "down" && multiMoveDown(state, action.targets))
    || (action.dir == "up" && multiMoveUp(state, action.targets))
    || state
  )

  if (subtype == "add_activity") return fixOrder(
    insertAt(state, action.itarget || state.length,
      getNewItem("activity", {
        city: action.activity.city,
        frozenPrice: action.activity.price,
        id: action.activity._id
      })
    )
  )

  if (subtype == "add_city") return fixOrder(
    insertAt(
      state, action.itarget || state.length,
      getNewItem("city", {city: action.city, transport: getEmptyTransport(action.city)})
    )
  )

  if (subtype == "add_note") {
    return fixOrder(
      insertAt(state, action.itarget || state.length, getNewItem("note", { internalText: action.payload.internalText, text: "" }))
    )
  }

  if (subtype == "add_day") return fixOrder(
    insertAt(state, action.itarget || state.length, getNewItem("day"))
  )


  if (subtype == "add_expense") return fixOrder(
    insertAt(
      state, action.itarget || state.length,
      { type: "expense", expense: cloneDeep(action.expense), key: `E${randstr()}` }
    )
  )

  if (subtype == "remove")  {
    if (!action.flag) {
      return (
        (itarget == 0 && state[1] && state[1].type != "day")
        || ((itarget == 0 && state.length == 1) ? state :  removeItem(state, itarget))
      )
    }
    else if (!(itarget == 0 && state.length == 1)) {
      let stateAux = state
      do {
        stateAux = removeItem(stateAux, itarget)
      } while (stateAux[itarget] && stateAux[itarget].type != "day")
      return stateAux
    }
    else return state
  }

  if (subtype == "edit_item") return state.map(
    (x, i) => (i != action.itarget ? x : { ...x, ...action.payload })
  )

  /* USING BLOCKS: */

  if (subtype == "add_block" || subtype == "replace_with_block") {
    const k = randstr(5)

    const agenda = cloneDeep(
      action.payload.blockRoute.agenda
        // HACK: there are some activity-items without id
        .filter(x => !(x.type == "activity" && !x.id))
        // avoid clashing references when same template is applied twice
        .map(x => addKeyToItem(x, k))
        // freeze prices
        .map(item => {
          if (
            item.type != "activity"
            || !action.payload.activities
            || !action.payload.activities[item.id]
          ) {
            return item
          }
          else {
            return {
              ...item,
              frozenPrice: cloneDeep(action.payload.activities[item.id].price)
            }
          }
        })
    )

    console.log("PAYLOAD")
    console.log(action.payload)
    console.log("AGENDA")
    console.log(agenda)

    if (subtype == "replace_with_block") {
      return agenda
    }
    else {
      return insertAt(state, action.itarget || state.length, agenda, { spread: true })
    }
  }

  /* */

  if (subtype == "repeat_expense") {
    const src = state[action.isrc]
    const newItem = getNewItem(src.type, { ref: src.ref || src.key })
    return insertAt(state, action.idst || action.isrc + 1, newItem)
  }

  if (subtype == "move_item") return fixOrder(
    moveInArray(state, action.itarget, action.newPos)
  )

  return state
}

/**
 *
 */

const renamingReducer = (state = "", action) => (
  action.subtype == "rename" ? action.payload.name : state
)

/**
 *
 */

const updateAction = action => dispatch => {
  dispatch({ type: ActionTypes.UPDATE_ONE_ROUTES, ...action, dontPersist: true })

  dispatch((dispatch2, getState) => dispatch2({
    type: ActionTypes.UPDATED_ONE_ROUTES,
    id: action.id,
    payload: getState().routes[action.id]
  }))
}

/**
 *
 */

const duck = createDuck(
  "ROUTES",
  getRoute,
  getRoutes,
  // custom actions:
  {
    // #TODO this is not being used. it should be called createDoc for that. check that we really don't need it
    // custom actions
    createRoute: (initials, cb) => {
      const id = randstr(16)
      let fixedInitials = initials

      if (cb) cb(id)

      // make sure first item is a day
      if (initials.agenda && initials.agenda[0].type != "day") {
        fixedInitials = {
          ...initials,
          route: [{ type: "day", key: "firstday" }, ...(initials.agenda)]
        }
      }

      return {
        id,
        type: ActionTypes.CREATE_ONE_ROUTES,
        payload: fixedInitials,
      }
    },

    cloneRoute: (clonedId, cb) => (dispatch, getState) => {
      const newId = randstr(16)
      const src = getState().routes[clonedId]

      const r = { ...src, _id: newId, name: (src.name ? `${src.name} '` : "") }

      if (cb) cb(newId)

      dispatch({
        type: ActionTypes.CREATE_ONE_ROUTES,
        id: newId,
        payload: r
      })
    },

    updateContent:  (id, subtype, itarget)  => updateAction({ subtype, id, itarget }),

    // #TODO doing the edits by the itarget is impractical in many cases, 
    // should use (or allow to also use) the item key
    
    addActivity:    (id, activity, itarget) => updateAction({ subtype: "add_activity",    id, activity, itarget }),
    addCity:        (id, city, itarget)     => updateAction({ subtype: "add_city",        id, city, itarget }),
    addDay:         (id, itarget)           => updateAction({ subtype: "add_day",         id, itarget }),
    remove:         (id, itarget, flag)     => updateAction({ subtype: "remove",          id, itarget, flag }),
    updateExpenses: (id, expenses)          => updateAction({ subtype: "update_expenses", id, expenses }),
    editItem:       (id, itarget, changes)  => updateAction({ subtype: "edit_item",       id, itarget, payload: changes }),
    addExpense:     (id, expense, itarget)  => updateAction({ subtype: "add_expense",     id, expense, itarget }),
    repeatExpense:  (id, isrc, idst)        => updateAction({ subtype: "repeat_expense",  id, isrc, idst }),
    multiMove:      (id, dir, targets)      => updateAction({ subtype: "multi_move",      id, dir, targets }),
    moveItem:       (id, itarget, newPos)   => updateAction({ subtype: "move_item",       id, itarget, newPos }),
    rename:         (id, name)              => updateAction({ subtype: "rename",          id, payload: { name } }),

    addNote: (id, itarget, text = "") => updateAction({ 
      subtype: "add_note", 
      id, 
      itarget, 
      payload: { internalText: text } 
    }),

    addBlock: (id, blockRoute, itarget) => (dispatch, getState) => {
      const activities = getRouteActivities(blockRoute, getState().activities)
      dispatch(updateAction({
        subtype: "add_block",
        id,
        payload: { blockRoute, activities },
        itarget
      }))
    },


    replaceWithBlock: (id, blockIgnored, blockRoute) => (dispatch, getState) => {
      const activities = getRouteActivities(blockRoute, getState().activities)
      dispatch(updateAction({
        subtype: "replace_with_block",
        id,
        payload: { blockRoute, activities }
      }))
    },
  },
  emptyRoute,
  // custom reducers
  {
    [ActionTypes.UPDATE_ONE_ROUTES]: (state = {}, action) => {
      const doc = state[action.id]

      return {
        ...state,
        [action.id]: {
          ...doc,
          name: renamingReducer(doc.name, action),
          agenda: agendaUpdatesReducer(doc.agenda, action),
          expenses: expensesUpdatesReducer(doc.expenses, action),
          usedTemplateRoutes: usedTemplatesReducer(doc.usedTemplateRoutes || [], action)
        }
      }
    }
  },
  {
    // @TODO it doesnt make sense to expunge routes, since trips aren't expunged
    // may be make them delete normally
    expunge: true
  }
)

export const createRoute = duck.actions.createDoc
export const receiveRoutes = duck.actions.receiveCollection
export const receiveRoute = duck.actions.receiveDoc
export const removeRoute = duck.actions.removeDoc
export const fetchRoutes = duck.actions.fetchCollection
export const updateRoute = duck.actions.updateDoc

export const updateContent = duck.actions.updateContent
export const addActivity = duck.actions.addActivity
export const addCity = duck.actions.addCity
export const addDay = duck.actions.addDay
export const addBlock = duck.actions.addBlock
export const addNote = duck.actions.addNote
export const remove = duck.actions.remove
export const updateExpenses = duck.actions.updateExpenses
export const editItem = duck.actions.editItem
export const addExpense = duck.actions.addExpense
export const repeatExpense = duck.actions.repeatExpense
export const multiMove = duck.actions.multiMove
export const moveItem = duck.actions.moveItem
export const rename = duck.actions.rename
export const replaceWithBlock = duck.actions.replaceWithBlock
export const cloneRoute = duck.actions.cloneRoute

export default duck
